// extracted by mini-css-extract-plugin
export var columnList = "_gj-0";